
import { Application } from "@/types/application";
import { ApplicationCard } from "./ApplicationCard";

interface ApplicationGridProps {
  applications: Application[];
  onUpdateApplication?: (app: Application) => void;
  onRemoveApplication?: (appId: string) => void;
}

export const ApplicationGrid = ({ 
  applications,
  onUpdateApplication,
  onRemoveApplication
}: ApplicationGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {applications.map(app => (
        <div key={app.id} className="hover:-translate-y-1 transition-all duration-300">
          <ApplicationCard 
            application={app} 
            onUpdate={onUpdateApplication}
            onRemove={onRemoveApplication}
          />
        </div>
      ))}
    </div>
  );
};
